/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplyingPlan,
    ApplyingPlanFromJSON,
    ApplyingPlanFromJSONTyped,
    ApplyingPlanToJSON,
} from './ApplyingPlan';

/**
 * 
 * @export
 * @interface GetApplyingPlanResponse
 */
export interface GetApplyingPlanResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetApplyingPlanResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetApplyingPlanResponse
     */
    message: string;
    /**
     * 
     * @type {ApplyingPlan}
     * @memberof GetApplyingPlanResponse
     */
    data: ApplyingPlan;
}

export function GetApplyingPlanResponseFromJSON(json: any): GetApplyingPlanResponse {
    return GetApplyingPlanResponseFromJSONTyped(json, false);
}

export function GetApplyingPlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetApplyingPlanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ApplyingPlanFromJSON(json['data']),
    };
}

export function GetApplyingPlanResponseToJSON(value?: GetApplyingPlanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ApplyingPlanToJSON(value.data),
    };
}

